module.exports = __webpack_public_path__ + "media/images/landing/persons/maxim-kozlov-21d62424fb0436bce06df9fc48eac872.jpg";